export interface VenueCategoryFilterType {
  selectedVenueCategories: server.dto.VenueCategories[]
}

export const getSortedVenueCategoryLabels = (filter: VenueCategoryFilterType) => {
  return filter.selectedVenueCategories.map(v => getLabel(v))
    .sort((a, b) => a.localeCompare(b));
};

export const getLabel = (category: server.dto.VenueCategories) => {
  return serverReference.venueCategories.find((pm) => pm.value === category)
    ?.text;
};

export const initialVenueCategoryFilter: VenueCategoryFilterType = {
  selectedVenueCategories: []
};
